import { LineSkeleton } from 'components/Skeleton/LineSkeleton'
import Styles from './ReviewTemplates.module.scss'

export const ReviewTemplatesSkeleton = () => (
  <div className={Styles.skeleton}>
    {Array(4)
      .fill(undefined)
      .map((_, idx) => (
        <div className={Styles.row} key={idx}>
          <div className={Styles.flex}>
            <LineSkeleton className={Styles.icon} />
            <LineSkeleton className={Styles.name} />
          </div>
          <LineSkeleton className={Styles.timesUsed} />
        </div>
      ))}
  </div>
)
